module.exports = __webpack_public_path__ + "static/img/aRZ_pic07.29903ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic07.jpg
// module id = AWE/
// module chunks = 5